export const parseToNumericOnly = (values) => {
    const sanitizedList = values.filter(v => v !== 'N/A');
    //console.log("[SANITIZED LIST OF NON-N/A METRICS]: ", sanitizedList)
    return sanitizedList
}

/*
[NOTE 1]: this strips 0's and nothing else - it is not an 'N/A' + 0 mix and matcher. If we ever need that, we build it separately.
[NOTE 2]: this one exists to ANSWER A QUESTION ("is every value in this set 0?"), not to clean a list we then go and use 
    Specifically for the single current edge case where we might have all non-dividend paying companies charted and therefore all 0's as the values, and therefore we wont have 'tasteful' max and min for the y-axis on the chart for user's eye
    since the range is 0 to 0 (i.e. all values in range are 0) and therefore the max and min are both 0, and it will cause the chart to look awkward
*/
export const parseNumericToNonZero = (values) => {
    const sanitizedList = values.filter(v => v !== 0);
    //console.log("[SANITIZED LIST OF NON-ZERO METRICS]: ", sanitizedList)
    return sanitizedList
}